import {createRouter, createWebHistory} from 'vue-router';

const router = createRouter({
    history: createWebHistory(),
    routes: [

        //文章列表
        {
            path: '/bpmoc-h5/articleList',
            name: "articleList",
            component: () => import('@/view/articleList')
        },

        //文章详情 带评论的
        {
            path: '/bpmoc-h5/',
            name: "details",
            component: () => import('@/view/articleDetails')
        },

        //文章详情 用于预览
        {
            path: '/bpmoc-h5/articleDetailsPreview',
            name: "articleDetailsPreview",
            component: () => import('@/view/articleDetailsPreview')
        },

        //文章详情 用于预览
        {
            path: '/bpmoc-h5/videoPreview',
            name: "videoPreview",
            component: () => import('@/view/videoPreview')
        },

        //文章详情 不带评论
        {
            path: '/bpmoc-h5/articleDetailsPage',
            component: () => import('@/view/articleDetailsPage')
        },

        //文章详情 管理端的
        {
            path: '/bpmoc-h5/articleDetailsPageManager',
            component: () => import('@/view/articleDetailsPageManager')
        },

        //服务
        {
            path: '/bpmoc-h5/service',
            component: () => import('@/view/service')
        },

        //视频和直播列表
        {
            path: '/bpmoc-h5/videoListener',
            component: () => import('@/view/videoListener')
        },

        //预告
        {
            path: '/bpmoc-h5/livePre',
            name: "LivePre",
            component: () => import('@/view/livePre')
        },
        //专题微页面
        {
            path: '/bpmoc-h5/smallPage',
            name: "smallPage",
            component: () => import('@/view/smallPage')
        },
        //专题微页面分类
        {
            path: '/bpmoc-h5/smallPageSort',
            component: () => import('@/view/smallPageSort')
        },
        //专题微页面
        {
            path: '/bpmoc-h5/topic',
            component: () => import('@/view/topic')
        },
        {
            path: '/bpmoc-h5/userAgreement',
            component: () => import('@/view/static/userAgreement')
        },
        {
            path: '/bpmoc-h5/privacyPolicy',
            component: () => import('@/view/static/privacyPolicy')
        },


        //祭祀 清明节
        {
            path: '/bpmoc-h5/worship',
            component: () => import('@/components/qingming.vue')
        },
    ],
});

export default router;
